import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatdater'
})
export class FormatDateRPipe implements PipeTransform {
    transform(input: string): string {
        if (typeof input === 'string') {
            return input.replace('T', ' ').replace('Z', '');
        }
        return null;
    }
}